import { useMemo } from 'react';

export const useSupportsPermissions = () => {
  const { canCreate, canUpdate, canDelete } = useMemo(
    () => ({
      // TODO: wire to PERMISSIONS.MEDIA_MANAGER.CREATE_SUPPORT once available.
      canCreate: true,
      // TODO: wire to PERMISSIONS.MEDIA_MANAGER.UPDATE_SUPPORT once available.
      canUpdate: true,
      // TODO: wire to PERMISSIONS.MEDIA_MANAGER.DELETE_SUPPORT once available.
      canDelete: true,
    }),
    []
  );

  return {
    canCreate,
    canUpdate,
    canDelete,
  };
};
